import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CollectorListItem,
  CollectorsConfig
} from '../../../domain/collector-profile.model';
import {
  getEngagementClass,
  getStateClass
} from '../collector-state-class.util';

@Component({
  selector: 'app-collector-assessment-card',
  templateUrl: './collector-assessment-card.component.html',
  styleUrls: ['../collector-card.shared.css']
})
export class CollectorAssessmentCardComponent {
  @Input() collector!: CollectorListItem;
  @Input() config!: CollectorsConfig;
  @Input() readOnly = false;
  @Output() change = new EventEmitter<void>();

  readonly getStateClass = getStateClass;
  readonly getEngagementClass = getEngagementClass;

  emitChange(): void {
    if (!this.readOnly) {
      this.change.emit();
    }
  }
}
